function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#d6d6d6",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 12.5,
  r: 12.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 12.5,
  r: 12,
  fill: "none"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(7 7)",
  fill: "none",
  stroke: "#d6d6d6",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 5.5,
  cy: 5.5,
  r: 5.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 5.5,
  cy: 5.5,
  r: 5,
  fill: "none"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-23611 -17357)",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23628,17384l-2-3,5-2-2,5Zm-10,0-2-5,5,2-2,3Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 23628.40234375 17382.8046875 L 23629.205078125 17380.796875 L 23627.515625 17381.470703125 L 23628.40234375 17382.8046875 M 23618.59765625 17382.8046875 L 23619.484375 17381.470703125 L 23617.794921875 17380.796875 L 23618.59765625 17382.8046875 M 23629 17384.001953125 L 23627.998046875 17384.001953125 L 23626 17381 L 23631 17379.001953125 L 23629 17384.001953125 Z M 23619.001953125 17384.001953125 L 23618 17384.001953125 L 23616.001953125 17379.001953125 L 23621 17381 L 23619.001953125 17384.001953125 Z",
  stroke: "none",
  fill: "#d6d6d6"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M23618.344,17384.549l-1.482-1.3a.992.992,0,0,1,0-1.5l1.482-1.3a1,1,0,0,1,1.654.752v1.3h4.211l2-2h4.586l-2,2H23620v1.293a1,1,0,0,1-1,1A.976.976,0,0,1,23618.344,17384.549Zm7.863-.047-2-2h4.584l2,2Z",
  transform: "translate(-23605 -17370)",
  fill: "none",
  stroke: "#d6d6d6",
  strokeWidth: 1
});

var SvgRetarget = function SvgRetarget(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "retarget",
    width: 27,
    height: 27.002,
    viewBox: "0 0 27 27.002",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRetarget, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/retarget.b15e8738.svg";
export { ForwardRef as ReactComponent };